import { memo, useEffect, useRef } from "react";
import { useAtomValue } from "jotai";
import { currentProjectAtom } from "~/stores/ProjectStore";
import { isMapLoadedDoneAtom } from "../stores/mapStore";
import { LngLatBounds } from "maplibre-gl";
import MapUtils from "../utils/MapUtils";

/**
 * ProjectDefaultViewController
 * Tự động zoom đến vùng quan tâm của project (boundingBox)
 * một lần duy nhất khi bản đồ load xong và project được nạp.
 */
const ProjectDefaultViewController = () => {
  const currentProject = useAtomValue(currentProjectAtom);
  const isMapLoadedDone = useAtomValue(isMapLoadedDoneAtom);
  const lastZoomedProjectIdRef = useRef<number | null>(null);

  useEffect(() => {
    if (!isMapLoadedDone || !currentProject?.id) {
      return;
    }

    // Chỉ tự động zoom 1 lần duy nhất cho mỗi project khi load xong
    if (lastZoomedProjectIdRef.current === currentProject.id) {
      return;
    }

    lastZoomedProjectIdRef.current = currentProject.id;

    // Nếu URL có chứa tọa độ chia sẻ (lat, lon/lng, zoom), giữ nguyên vị trí URL và không zoom đè
    const searchParams = new URLSearchParams(window.location.search);
    const hasUrlLocation =
      searchParams.has('lat') &&
      (searchParams.has('lon') || searchParams.has('lng')) &&
      searchParams.has('zoom');

    if (hasUrlLocation) {
      console.log('ProjectDefaultViewController - URL contains specific coordinates, skipping project boundingBox zoom');
      return;
    }

    if (currentProject.boundingBox) {
      try {
        const bounds = new LngLatBounds(JSON.parse(currentProject.boundingBox));
        MapUtils.zoomToDefaultView(bounds);
        console.log('Auto zoom to project bounds on load:', currentProject.boundingBox);
      } catch (error) {
        console.error('Failed to parse project boundingBox:', error);
        MapUtils.zoomToDefaultView();
      }
    }
  }, [isMapLoadedDone, currentProject?.id, currentProject?.boundingBox]);

  return null;
};

export default memo(ProjectDefaultViewController);
